function Invoice(invoiceData) {
    let invoice = invoiceData || {};
    this.id = invoice.id;
    this.totalAmount = invoice.totalAmount;
    this.currency = invoice.currency;
    this.status = invoice.status;
    this.issuedDate = new Date(invoice.issuedDate);
    this.billedDate = invoice.billedDate === '0001-01-01T00:00:00' ? null: new Date(invoice.billedDate);
    this.dueDate = invoice.dueDate === '0001-01-01T00:00:00' ? null: new Date(invoice.dueDate);
    this.number = invoice.number;
}

module.exports = Invoice;